/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/core';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import { StackParams } from '../../../../data/types/navigation';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import SinistreListComponent from '../../../components/Sinistres/SinistreListComponent';
import { IDataWs } from '../../../../data/types/interface/Sinistres/sinistre';

type NavigationProps = StackNavigationProp<StackParams, 'Details'>;

export const FSuivreSinistre = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const {sinistreUser, user} = props;
  const [listSinistre, setListSinistre] = useState<IDataWs[]>();

  const onRefresh = React.useCallback(() => {}, []);
  const {navigate} = useNavigation<NavigationProps>();
  
  const formatDto = (data: any) => {
    const _result: IDataWs = {
      agence: data.agence,
      circonstanceAccident: data.circonstanceAccident,
      dateSinistre: data.dateSinistre,
      description: data.description,
      estimationPrejudice: data.estimationPrejudice,
      heureAccident: data.heureAccident,
      idx: data.id,
      immatriculation: data.immatriculation,
      nomDeclarant: data.nomDeclarant,
      numeroPolice: data.numeroPolice,
      pieceJointeAgence: data.pieceJointeAgence,
      statut: data.statut,
      telephone: data.telephone,
      type: data.type,
      version: data.version,
      date: data.dateSinistre,
    };

    return _result;
  };

  const handleClick = (item: IDataWs) => {
    navigate('DetailSinistre', {data: item, id: item.idx});
  };

  const getListSinistres = (id: string) => {
    setIsLoading(true);
    sinistreUser(
      {},
      (res: any) => {
        if (res && res.listSinistre) {
          const _list = res.listSinistre.data ? res.listSinistre.data : [];
          const _data: IDataWs[] =
            _list &&
            _list.map((elt: any) => {
              return formatDto(elt);
            });
          _data && _data.length > 0 && setListSinistre(_data);
        }
        setIsLoading(false);
      },
      `${id}`,
    );
  };

  useEffect(() => {
    const id = user.data.utilisateur.id;
    getListSinistres(id);
  }, [user && user.data && user.data.utilisateur && user.data.utilisateur.id]);

  useEffect(() => {}, [listSinistre]);

  return (
    <View>
      <SinistreListComponent
        datas={listSinistre}
        isLoading={isLoading}
        refreshList={onRefresh}
        handleClick={handleClick}
      />
    </View>
  );
};

export const SuivreSinistre: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FSuivreSinistre);
